// @flow
import styled from 'styled-components';
import colors from '../../assets/css/colors';

export const BorderedThinIcon = styled.div`
	background: ${({ background }) => background || 'transparent'};
	border-radius: 2px;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid ${colors.nrlGreen};
	width: 20px;
	height: 20px;
	> svg {
		padding: ${({ padding }) => padding || '0'};
		box-sizing: border-box;
	}
`;
export default BorderedThinIcon;


// WEBPACK FOOTER //
// ./src/components/BorderedThinIcon/index.js